import { SharedSurveyProgressRing } from '@/shared-survey';

import SurveyAiFormsInstructionsModal from './survey-ai-forms-instructions-modal';
import SurveyAiFormsModeToggle from './survey-ai-forms-mode-toggle';
import type { ViewMode } from './survey-ai-forms.types';

interface Props {
  progress: number;
  estimatedTotalTimeInSeconds: number;
  viewMode?: ViewMode;
  onViewModeToggle?: () => void;
  showInstructions?: boolean;
  onCloseInstructions?: () => void;
  isAIFormAssistanceEnabled?: boolean;
}

export default function SurveyAiFormsAiSectionHeader({
  progress,
  estimatedTotalTimeInSeconds,
  viewMode = 'ai',
  onViewModeToggle,
  showInstructions,
  onCloseInstructions,
  isAIFormAssistanceEnabled = true,
}: Props) {
  return (
    <div
      data-test='ai-section-header'
      className='relative mb-8 flex items-start justify-between'
    >
      <SharedSurveyProgressRing
        estimatedTotalTimeInSeconds={estimatedTotalTimeInSeconds}
        progress={progress}
        size={48}
        strokeWidth={3}
        backgroundColor='#e5e7eb'
      />

      {/* Instructions and Toggle */}
      <div className='relative flex items-start gap-2'>
        {showInstructions && onCloseInstructions && (
          <SurveyAiFormsInstructionsModal onClose={onCloseInstructions} />
        )}

        {isAIFormAssistanceEnabled && onViewModeToggle && (
          <div className='h-11 w-18'>
            <SurveyAiFormsModeToggle
              viewMode={viewMode}
              onToggle={onViewModeToggle}
            />
          </div>
        )}
      </div>
    </div>
  );
}
